jQuery(function($) {
  var body = $('body');

  $('.header__small__menu--toggle').on('click', function(e) {
    body.toggleClass('menu-active');
    body.removeClass('search-active');
    $('.header__search').hide();
    e.preventDefault();
  });

  function mobileSearchOpen() {
    $('.header__search').stop().slideToggle();
    body.removeClass('menu-active');
    body.toggleClass('search-active');
    return false;
  }

  function headerDropDown() {
    $(this).parent().find('.submenu').stop().slideToggle();
    $(this).parent().toggleClass('info-active');
    $('.header__search').hide();
    $(this).parent().parent().children().removeClass('search-active');
    return false;
  }

  function searchOpen() {
    $('.header__search').stop().slideToggle();
    $(this).toggleClass('search-active');
    $('.info-active .submenu').stop().slideToggle();
    $(this).parent().children().removeClass('info-active');
    return false;
  }



  $('.header__search').hide();
  $('.submenu').hide();
  $('.menu__item:first-child > a').on('mousedown touchstart', headerDropDown);
  $('.menu__item:last-child').on('mousedown touchstart', searchOpen);
  $('.header__small__search--toggle').on('mousedown touchstart', mobileSearchOpen);
});




